import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Chip,
} from '@mui/material';
import {
  AccessTime,
  Edit,
  Delete,
} from '@mui/icons-material';

const MatchNotes = ({
  notes,
  editNote,
  deleteNote,
  isComplete
}) => {
  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Match Notes
      </Typography>
      {notes.length === 0 ? (
        <Typography>No notes added yet.</Typography>
      ) : (
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center' }}><AccessTime /> Time (min)</Box></TableCell>
                <TableCell sx={{ minWidth: 100 }}>Half</TableCell>
                <TableCell sx={{ minWidth: 300 }}>Notes</TableCell>
                <TableCell sx={{ minWidth: 120 }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notes.map((note, index) => (
                <TableRow key={index}>
                  <TableCell>{note.time}</TableCell>
                  <TableCell>
                    <Chip
                      label={note.half === 1 ? '1st Half' : '2nd Half'}
                      color={note.half === 1 ? 'primary' : 'secondary'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{note.note}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => editNote(index)} disabled={isComplete}>
                      <Edit />
                    </IconButton>
                    <IconButton onClick={() => deleteNote(index)} disabled={isComplete}>
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default MatchNotes;